import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

export const fetchCart = async () => {
  const { data } = await CLIENT.get(ENDPOINTS.CART.root);

  return data?.carts || [];
};

export const saveCart = async (productQuantities) => {
  const { data } = await CLIENT.put(ENDPOINTS.CART.root, { productQuantities });

  return data;
};
